import React, { useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import
{
  CardBody,
  Container,
  Row,
  Card,
  Table,
  Badge,
  Col,
  Alert,
} from "reactstrap";

//Import Breadcrumb
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import TableContainer from "../../../Components/Common/TableContainer";
import dummyImg from "../../../assets/images/users/user-dummy-img.jpg";

// import
// {
//   getScannesAgentIn,
//   getParainageInfoAgent,
// } from "../../../common/data";

// import Revenue from "../../Dashboard/Revenue";

//redux
import { useSelector, useDispatch } from "react-redux";
import { Link, Redirect, useParams, withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import axiosInstance from "../../../axiosConfig";
import Loader from "../../../Components/Common/Loader";
import StatistiquesDetail from "../../../Components/Common/StatistiquesDetail";
import Key from "../../../key";


const ImageWithFallback = ( { src, fallback, ...props } ) =>
{
  const [ imgSrc, setImgSrc ] = useState( fallback );

  useEffect( () =>
  {
    if ( src )
    {
      fetch( src, { method: "HEAD" } )
        .then( ( res ) =>
        {
          if ( !res.ok ) throw new Error( "Image not found" );
          setImgSrc( src );
        } )
        .catch( () => setImgSrc( fallback ) );
    } else
    {
      setImgSrc( fallback );
    }
  }, [ src, fallback ] );

  return <img src={ imgSrc } onError={ () => setImgSrc( fallback ) } { ...props } />;
};


const AgentDetail = ( props ) =>
{
  const [ loading, setLoading ] = useState( true );

  //Début code pour get le agent sélectionné
  const agentId = useParams( "id" );
  // console.log( "numcon", agentId.id );

  const url = process.env.REACT_APP_API_URL;
  const token = JSON.parse( localStorage.getItem( "authUser" ) )
    ? JSON.parse( localStorage.getItem( "authUser" ) ).access
    : null;
  // if ( token )
  //   axios.defaults.headers.common[ "Authorization" ] = "Bearer " + token;

  const [ selectagent, setSelectAgent ] = useState( {} );
  const [ agentScannesIn, setAgentScannesIn ] = useState( [] );

  useEffect( () =>
  {
    const fetchData = async () =>
    {
      try
      {
        const agent_data = await axiosInstance.get(
          `/getAgentById/?id=${ agentId.id }`
        );

        if ( agent_data?.data )
        {
          // const data = await axios.get( `https://stepnode.inawo.pro/agentdetail/?id=${ agentId.id }/` );
          const agentData = agent_data.data.data;
          setSelectAgent( agentData );

          console.log( "agentData: ", agentData );

          // const scannesAgentIn = await getScannesAgentIn( agentData.user_id );
          // const sortAgentCourse = scannesAgentIn.sort( ( a, b ) =>
          // {
          //   // Prioriser les noms non vides
          //   const aHasName =
          //     a.last_name.trim() !== "" || a.first_name.trim() !== "";
          //   const bHasName =
          //     b.last_name.trim() !== "" || b.first_name.trim() !== "";
          //   return aHasName - bHasName; // Les noms non vides passent en premier
          // } );
          // //   console.log("sortAgentCourse: ", sortAgentCourse);
          // // console.log("scannesAgentIn: ", scannesAgentIn);
          // setAgentScannesIn( scannesAgentIn );

        }

        // console.log("revenuScannesAgent: ", revenuScannesAgent);
      } catch ( err )
      {
        console.error(
          `Erreur de récupération des données de l'agent ${ agentId.id }: `,
          err
        );
      }
      setLoading( false );
    };
    fetchData();
  }, [ agentId, url ] );

  //Fin code

  const [ agentList, setAgentList ] = useState( [] );

  function formatDate ( date )
  {
    const dateObject = new Date( date ).toLocaleDateString( "fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    } );
    return dateObject;
  }

  const columnsTable = useMemo(
    () => [
      {
        Header: "Nom Conducteur",
        accessor: "last_name",
        filterable: false,
        Cell: ( cell ) =>
        {
          return cell.row.original.last_name;
        },
      },
      {
        Header: "Prénom Conducteur",
        accessor: "first_name",
        filterable: false,
        Cell: ( cellProps ) =>
        {
          return cellProps.row.original.first_name;
        },
      },
      {
        Header: "Date",
        accessor: "date",
        filterable: false,
        Cell: ( cellProps ) =>
        {
          return formatDate( cellProps.row.original.date );
        },
      },

      {
        Header: "status",
        accessor: "status",
        filterable: true,
        // Cell: (cellProps) => {
        //   return formatDate(cellProps.row.original.status);
        // },
      },
      {
        Header: "Type de course",
        accessor: "type",
        filterable: true,
      },
    ],
    []
  );

  const columnStatistique = [
    {
      title: "Scannes",
      prefix: "",
      suffix: "",
      value: agentScannesIn.length || 0,
    },
  ];

  document.title = "Détails Agents | Takci";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={ props.t( "Détails Agent" ) }
            pageTitle="Agents"
            pageTitleLink="/security"
          />

          <Row className="g-2">
            {/* { error && error ? <Alert color="danger">{ error }</Alert> : null }
            { success ? <Alert color="success"> { success }</Alert> : null } */}
            { !loading ? (
              Object.keys( selectagent ).length > 0 ? (
                <>
                  <Row className="mb-3">
                    <Card
                      className="h-100 w-100 shadow-lg"
                      style={ { borderLeft: "5px solid #01064a" } }
                    >
                      <CardBody>
                        <div className="d-flex">
                          <div className="mx-3">
                            <ImageWithFallback
                              src={ Key.photoURL + selectagent.photo }
                              fallback={ dummyImg }
                              alt=""
                              className="avatar-md rounded-circle img-thumbnail"
                            />

                            {/* {selectagent.photo} */ }
                          </div>
                          <div className="flex-grow-1 align-self-center">
                            <div className="text-muted">
                              <h3
                                className="fw-bolder"
                                style={ { color: "#01064a" } }
                              >
                                { selectagent.username || (
                                  <Badge color="danger">Non renseignée</Badge>
                                ) }
                              </h3>
                              <p className="mb-1">
                                { props.t( "Agent" ) +
                                  " #" +
                                  ( selectagent.id || 1 ) }
                              </p>
                            </div>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Row>

                  <Col xxl={ 4 }>
                    <Card className="h-100 w-100">
                      <CardBody>
                        <h5 className="card-title mb-3">
                          { props.t( "Personal details" ) }
                        </h5>
                        <div className="table-responsive">
                          <Table className="table-borderless mb-0">
                            <tbody>
                              <tr>
                                <th className="ps-0" scope="row">
                                  { props.t( "Pseudo" ) }:
                                </th>
                                <td className="text-muted">
                                  { selectagent.username || (
                                    <Badge color="danger">Non renseignée</Badge>
                                  ) }
                                </td>
                              </tr>
                              <tr>
                                <th className="ps-0" scope="row">
                                  { props.t( "Phone number" ) }:
                                </th>
                                <td className="text-muted">
                                  { ( selectagent.telephone && (
                                    <a href={ `tel: ${ selectagent.telephone }` }>
                                      { selectagent.telephone }
                                    </a>
                                  ) ) || (
                                      <Badge color="danger">Non renseignée</Badge>
                                    ) }
                                </td>
                              </tr>

                              {
                                selectagent.nom && selectagent.event_id &&
                                <tr>
                                  <th className="ps-0" scope="row">
                                    { props.t( "Evénement" ) }:
                                  </th>
                                  <td className="text-muted">
                                    { ( selectagent.nom && selectagent.event_id && (
                                      <Link to={ `/evenements/${ selectagent.event_id }` }>
                                        { selectagent.nom }
                                      </Link>
                                    ) ) || (
                                        <Badge color="danger">Non renseignée</Badge>
                                      ) }
                                  </td>
                                </tr>
                              }

                              <tr>
                                <th className="ps-0" scope="row">
                                  { props.t( "Id de connexion" ) }:
                                </th>
                                <td className="text-muted">
                                  { ( selectagent.id_connexion && (
                                    selectagent.id_connexion
                                  ) ) || (
                                      <Badge color="danger">Non renseignée</Badge>
                                    ) }
                                </td>
                              </tr>

                              <tr>
                                <th className="ps-0" scope="row">
                                  { props.t( "Statut" ) }
                                </th>
                                <td className="text-muted">
                                  {
                                    selectagent.status_activation === 1 ?
                                      <Badge color="success" className="p-1 text-sm text-light rounded-lg">Activer</Badge>
                                      :
                                      <Badge color="danger" className="p-1 text-sm text-light rounded-lg">Désactiver</Badge>
                                  }
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col xxl={ 8 }>
                    <Card className="h-100 w-100">
                      <StatistiquesDetail data={ columnStatistique } />
                      { agentScannesIn.length > 0 ? (
                        <Card>
                          <CardBody>
                            <div className="table-card gridjs-border-none pb-2">
                              <TableContainer
                                columns={ columnsTable }
                                data={ agentScannesIn || [] }
                                isGlobalFilter={ false }
                                isAddUserList={ false }
                                customPageSize={ 10 }
                                divClass="table-responsive"
                                tableClass="mb-0 table-borderless"
                                theadClass="table-light text-muted"
                              />
                            </div>
                          </CardBody>
                        </Card>
                      ) : (
                        <Alert color="warning">
                          Aucun historique de scanne disponible.
                        </Alert>
                      ) }
                    </Card>
                  </Col>
                </>
              ) : (
                <Col
                  lg="12"
                  className="p-4 border-top border-top-dashed justify-center"
                >
                  <h6 className="text-muted text-uppercase fw-semibold mb-4">
                    Aucun Agent associé
                  </h6>
                </Col>
              )
            ) : (
              <>
                <div className="text-center my-3">
                  <Loader style={ { color: "#014c94" } } />
                  <h2>Chargement...</h2>
                </div>
              </>
            ) }
          </Row>
          <ToastContainer closeButton={ false } />
        </Container>
      </div>
    </React.Fragment>
  );
};

AgentDetail.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter( withTranslation()( AgentDetail ) );
